import { z } from 'zod';
/** Empty scope is the explicit legacy institution-wide grant. */
export const personDirectoryGrantScopeSchema = z
    .object({
    personIds: z.array(z.string().uuid()).optional(),
    self: z.boolean().optional(),
    delegations: z.literal('canteen').optional(),
})
    .strict();
export const delegationDirectoryAudienceSchema = z
    .object({
    institutionId: z.string().uuid(),
    accountId: z.string().uuid(),
    personId: z.string().uuid(),
    personIds: z.array(z.string().uuid()),
})
    .strict();
